// An interrupted stream is not a completed assistant message. Restore the
// composer without emitting the message-ready/audio-complete events.
function recoverWorkerError(service, message) {
  service.removeChatLoader(service.chatElement);
  service.chatMessageService?.reset();
  if (service.chatInput) service.chatInput.disabled = false;
  service.chatSubmitBtn.disabled = false;
  service.updateInputBarState();
  const existing = service.chatElement.querySelector?.('.js-worker-error-message');
  const alert = existing || document.createElement('div');
  alert.className = 'alert alert-danger js-error-message js-worker-error-message';
  alert.setAttribute('role', 'alert');
  alert.textContent = message || 'The response was interrupted. Please try again.';
  if (!existing) service.chatElement.appendChild(alert);
}
module.exports = { recoverWorkerError };
